import { contact } from '../../constants'
import React from 'react'

export default function SupportContact() {
  return <a href={contact.tel}>{contact.number}</a>
}
